export default "__VITE_ASSET__DWCsv265__"